<template>
  <div class="layoutBookingDetails">
      <div v-if="getBooking" class="booking">
        <v-card elevation="0" class="cardBooking">
          <!-- Start Details  -->
          <v-card-title class="pt-7">{{
          $t("BookingDetails.title")
        }}</v-card-title>
        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.id")
              }}</span>
              {{ getBooking.id}}
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.trStart")
              }}</span>
              <span>{{ new Date(getBooking.dateStart).toLocaleString('fr-FR') }}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.dateEnd")
              }}</span>
             <span>{{ new Date(getBooking.dateEnd).toLocaleString('fr-FR') }}</span>
            </v-card-text>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.User")
              }}</span>
              <span>{{ getBooking.user.firstName}} {{ getBooking.user.lastName}}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.StatuUser")
              }}</span>
              <span v-for="type in getBooking.user.types">{{type}}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.UserCompany")
              }}</span>
              <span>popo{{ getBooking.user.company}}</span>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.Center")
              }}</span>
             <span>{{getBooking.center.name}}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.Room")
              }}</span>
             <span>{{getBooking.center.address}}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("BookingDetails.reason")
              }}</span>
              <span>{{getBooking.reason}}</span>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
    <v-col>
    <span class="font-weight-medium">{{ $t("BookingDetails.Complement") }}</span>
    <br />
    <pre style="white-space: pre-wrap">
      {{ getBooking.complement ? getBooking.complement : $t("BookingDetails.ComplementNoComment") }}
    </pre>
  </v-col>
</v-row>
          <!-- End Details Intervention Memento -->
        </v-card>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddEventCard from '../../../../components/components-planning/public/calendar/grid-scheduler/add-event/AddEventCard.vue';
export default {
  components: { AddEventCard },
  computed: {
    ...mapGetters("bookingModule",{bookingById:"getBookingById"}),
    getBooking()
    {
        return this.bookingById(parseInt(this.$route.params.id));
    },
  },
};
</script>

<style lang="scss">
.layoutBookingDetails {
  margin:0 1rem;
  display:flex;
  justify-content:center;
  width:100%;
}

.cardBooking {
  padding: 3rem 3rem;
}

.before-state {
  color: #b6b6b6;
  font-style: italic;
}

.right {
  font-size: 0.9rem;
}
